module.exports = __webpack_public_path__ + "img/smoke.ca116019.svg";